
/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-11 17:13:32
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description:系统介绍详情
 * 
 * @param {
 * }
 * @return {*}
 */
export const findCheckeIntroduceDetail = (data) => {
    return axios.request({
        url: `${API_MAIN}/findCheckeIntroduceDetail`,
        method: 'post',
        data
    })
}
/**
 * @description:操作指南详情
 * 
 * @param {
 * keyId //1，2，3
* }
* @return {*}
*/
export const findCheckedBxtjGuideDetail = (data) => {
   return axios.request({
       url: `${API_MAIN}/findCheckedBxtjGuideDetail`,
       method: 'post',
       data
   })
}

/**
 * @description:常见问题左侧菜单
 * 
 * @param {
* keyId //1，2，3
* }
* @return {*}
*/
export const findQuestionSortTreeList = (data) => {
   return axios.request({
       url: `${API_MAIN}/findQuestionSortTreeList`,
       method: 'post',
       data
   })
}
/**
 * @description:常见问题左侧菜单
 * 
 * @param {
* keyId //1，2，3
* }
* @return {*}
*/
export const findCheckedBxtjQuestionPage = (data) => {
   return axios.request({
       url: `${API_MAIN}/findCheckedBxtjQuestionPage`,
       method: 'post',
       data
   })
}







// WEBPACK FOOTER //
// ./src/api/system.js